import BaseApi from "./baseApi";

class helpApi extends BaseApi {
  async getAllTickets(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/help/get-all-tickets",
      data: data,
      method: "post",
    });
  }

  async deleteTicket(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/help/delete-ticket",
      data: data,
      method: "post",
    });
  }

  async updateStatus(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/help/update-status",
      data: data,
      method: "post",
    });
  }

  async sendTicketMsg(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/help/send-ticket-msg",
      data: data,
      method: "post",
    });
  }

}

export default helpApi;
